import { motion } from 'framer-motion';
import { RITUAL } from './data';

// RITUAL — long magazine essay per product. Each étape is a full-width spread:
// large image left, formula table right, ingredient ledger below.
export default function Ritual() {
  return (
    <div className="bg-[#F2EBE0] text-[#1B1A18]">
      <section className="pt-12 pb-10 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#6F7E62]/20">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B8654A] mb-4">— Le rituel · trois étapes</p>
        <h1 className="font-serif text-[44px] sm:text-[72px] lg:text-[112px] leading-[0.92] tracking-[-0.02em]">Three things, <span className="italic text-[#6F7E62]">in order</span>.</h1>
      </section>

      <section className="space-y-32 py-20">
        {RITUAL.map((r, i) => (
          <motion.article key={r.t} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: '-15%' }}
            className={`max-w-[1500px] mx-auto px-8 lg:px-14 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ${i % 2 === 1 ? 'lg:[direction:rtl]' : ''}`}>
            <div className="lg:[direction:ltr] aspect-[4/5] overflow-hidden">
              <img src={r.img} alt={r.t} className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="lg:[direction:ltr]">
              <p className="font-serif italic text-3xl lg:text-4xl text-[#B8654A]">{r.step}</p>
              <h2 className="font-serif text-5xl lg:text-7xl mt-2 leading-[0.95]">{r.t}</h2>
              <p className="font-serif italic text-lg lg:text-xl text-[#1B1A18]/65 mt-6 leading-[1.5]">{r.product}</p>
              <p className="text-base text-[#1B1A18]/85 mt-6 leading-[1.7] max-w-md">{r.d}</p>

              {/* Formula card */}
              <div className="border border-[#6F7E62]/30 bg-[#E8E0D2] p-6 mt-8 max-w-md">
                <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B8654A] mb-3">Formula · key ingredients</p>
                <ul className="text-sm text-[#1B1A18]/85 space-y-1.5 leading-relaxed">
                  {['Cold-pressed jojoba (Provence)', 'Almond extract (Aix)', 'Immortelle infusion · 9 months', 'Sea-buckthorn oil (Mediterranean)'].slice(0, i + 2).map(ing => (
                    <li key={ing} className="flex items-start gap-2"><span className="text-[#6F7E62] mt-1">·</span>{ing}</li>
                  ))}
                </ul>
              </div>

              <div className="mt-8 flex items-center gap-6">
                <p className="font-serif text-3xl text-[#B8654A]">{r.price.split(' · ')[0]}</p>
                <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#6F7E62]/85">{r.price.split(' · ')[1]} · refillable</p>
              </div>
              <button className="mt-6 bg-[#1B1A18] text-[#F2EBE0] px-8 py-3.5 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#B8654A] transition-colors" data-testid={`skin-ritual-add-${r.t}`}>Add to ritual →</button>
            </div>
          </motion.article>
        ))}
      </section>
    </div>
  );
}
